import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import { type IActionItemByMonth, type IActionItemsByMonthKeys } from '../model/actionItemsByMonth';

const actionItemsByMonthKey = (
  keys: IActionItemsByMonthKeys,
): [string, number, number, boolean, Array<number>, ITableSorting] => [
  'actionItemsByMonth',
  keys.year,
  keys.month,
  keys.includeUnverifiedSavings,
  keys.locationIds,
  keys.sorting,
];

const actionItemsByMonthFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof actionItemsByMonthKey>>) => {
  const orderBy = queryKey[5].id ? queryKey[5].id : undefined;
  const direction = !queryKey[5].id ? undefined : queryKey[5].desc ? 'desc' : 'asc';

  const params = {
    year: queryKey[1],
    month: queryKey[2],
    include_unverified_savings: +queryKey[3],
    location_ids: queryKey[4],
    sort: {
      field: orderBy,
      direction: direction,
    },
  };

  return apiClient.get<{ data: IActionItemByMonth[] }>(
    `${APP_API_URL_V2}fsd/action-item/cost-savings/action-items-for-month`,
    {
      params,
      paramsSerializer: {
        serialize: (params) => qs.stringify(params),
      },
    },
  );
};

const actionItemsByMonthSelect = ({ data }: AxiosResponse<{ data: IActionItemByMonth[] }>) => {
  if (!data.data) {
    return [];
  }
  return data.data;
};

export const useActionItemsByMonthQuery = (keys: IActionItemsByMonthKeys) => {
  return useQuery({
    queryKey: actionItemsByMonthKey(keys),
    queryFn: actionItemsByMonthFn,
    enabled: keys.enabled,
    select: actionItemsByMonthSelect,
  });
};
